import { spApi } from './sp';

export const toggleFaqApi = spApi.injectEndpoints({
  endpoints: (builder) => ({

    toggleFaq: builder.mutation({
      query: ({ businessId, faqId }) => ({
        url:    `/business/${businessId}/faqs/${faqId}/toggle`,
        method: 'PATCH',
        body:   {}
      }),
      invalidatesTags: ['businessDetails']
    }),

  }),
  overrideExisting: false,
});

export const { useToggleFaqMutation } = toggleFaqApi;